<template>
	<div id="energyRightBottom1">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">用能数据报表</span>
				</div>
			</div>
			<div class="d-flex ml-3 pt-3 pb-3">
				<div>
					<el-date-picker v-model="value" type="daterange" align="right" value-format="yyyy-MM-dd"
						unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</div>
				<div>
					<el-button class="ml-3" type="primary" size="medium" @click="timeChange">查询</el-button>
					<!-- <el-button type="primary" @click='toExcel' size="medium">导出</el-button> -->
				</div>
			</div>
			<div class="d-flex jc-center body-box">
				<el-table :data="reportList" highlight-current-row style="width: 90%;margin: 0 auto;" ref="table" height="0">
					<el-table-column prop="region_name" label="区域" align="center"></el-table-column>
					<el-table-column prop="location" label="编号" align="center"></el-table-column>
					<el-table-column prop="dnsj" label="用能" align="center"></el-table-column>
				</el-table>
				<!-- <dv-scroll-board :config="config" style="width: 90%; height: 3.8rem;margin: 0 auto;" /> -->
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import Blob from '@/excel/Blob';
	export default {
		data() {
			return {
				value: this.getNowTime(),
				config: {
					header: ["区域", "编号", "用能"],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					// columnWidth: [120],
					align: ["center", "center", "center"],
				},
				reportList: []
			};
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.energyReport();
				},
			}
		},
		mounted() {
			this.energyReport();
		},
		methods: {
			timeChange() {
				this.energyReport();
			},
			getNowTime() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate() - 1;
				var endDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (endDate >= 0 && endDate <= 9) {
					endDate = "0" + endDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				var enddate = year + seperator1 + month + seperator1 + endDate;
				// console.log(currentdate)
				return [enddate, enddate];
			},
			async energyReport() {
				this.reportList = []
				let dataObj = {
					building_id: this.building,
					start_time: this.value[0],
					end_time: this.value[1]
				}
				await this.$axios.get("/api/buildings/energyReport", {
					params: dataObj
				}).then(res => {
					let reportList = []
					let reportData = []
					for (let item of res.data.data) {
						reportData.push({
							region_name: item.region_name,
							location: item.location,
							dnsj: item.dnsj
						})
						reportList.push([item.region_name, item.location, item.dnsj])
					}
					this.reportList = res.data.data
					this.config = {
						header: ["区域", "编号", "用能"],
						data: reportList,
						rowNum: 6, //表格行数
						headerHeight: 30,
						headerBGC: "#085E7D", //表头
						oddRowBGC: "#0f1325", //奇数行
						evenRowBGC: "#171c33", //偶数行
						index: false,
						// columnWidth: [120],
						align: ["center", "center", "center"],
					}
				})
			},
			toExcel() {
				// console.log(this.reportList)
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('@/excel/Export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
					const tHeader = ['区域', '编号', '用能']; // 导出的表头名信息
					const filterVal = ['region_name', 'location', 'dnsj']; // 导出的表头字段名，需要导出表格字段名
					const list = this.reportList;
					const data = this.formatJson(filterVal, list);

					export_json_to_excel(tHeader, data, '报表'); // 导出的表格名称，根据需要自己命名
				})
			},
			//格式转换，直接复制即可
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss">
	#energyRightBottom1 {
		height: 5.65rem;
		width: 6.2125rem;

		.body-box {
			width: 100%;
			height: 3.8rem;
			
			.dv-scroll-board .header{
				background: linear-gradient(rgba(0,0,0,0), #1C3B68) !important;
			}
			.rows .row-item{
				background-color: rgba(255,255,255,0) !important;
			}
		}

		.el-input__inner {
			background: none;
			border: 0;
			color: #fff;
		
			.el-range-input {
				background: none;
				border: dimgray solid 1px;
				border-radius: 3px;
				color: #fff;
			}
		
			.el-range-separator {
				color: #fff;
				margin-right: 8px;
			}
		}
	}
</style>
